import { useCallback, useState } from "react";

import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

import { Button, Divider, Form, Message, TextArea } from "semantic-ui-react";

import { Input } from "simplydo/react/component-library";

import api from "api";
import { useAppSelector } from "store";

type ReportContentProps = {
  forType?: string;
  forId?: string;
  reportUrl?: string;
  onComplete?: () => void;
};

const ReportContent = ({
  forType,
  forId,
  reportUrl,
  onComplete,
}: ReportContentProps) => {
  const [location, setLocation] = useState<string>(reportUrl ?? "");
  const [description, setDescription] = useState<string>("");
  const user = useAppSelector((state) => state.user);
  const [email, setEmail] = useState<string>(user?.emails[0]?.address ?? "");
  const { t } = useTranslation();

  const reportContent = useCallback(() => {
    api.auth.reportContent(
      { forType, forId, description, email, location },
      () => {
        toast.success("Report submitted successfully");
        setDescription("");
        setLocation("");
        onComplete?.();
      },
      () => {
        toast.error("Failed to submit report");
      },
    );
  }, [forType, forId, description, email, location, onComplete]);

  return (
    <Form>
      <h2>{t("reportContent.title")}</h2>
      <Divider hidden />
      <p>{t("reportContent.onlineSafety")}</p>
      <p>{t("reportContent.contentModeration")}</p>
      <p>{t("reportContent.reportReviews")}</p>
      <Divider section hidden />
      <h4>{t("reportContent.contentTitle")}</h4>
      <p>{t("reportContent.reportLocationMessage")}</p>
      <Input
        placeholder="https://simplydo.co.uk"
        value={location}
        fluid
        onChange={(e) => setLocation(e.target.value)}
      />
      <Divider hidden />
      <h4>{t("reportContent.describeIssueTitle")}</h4>
      <p>{t("reportContent.describeIssueContent")}</p>
      <TextArea
        fluid
        placeholder="Please provide as much detail as possible."
        onChange={(e) => setDescription(e.target.value)}
        value={description}
      />
      <Divider hidden />
      <h4>{t("reportContent.contactTitle")}</h4>
      <p>{t("reportContent.contactDescription")}</p>
      <Input
        fluid
        placeholder={t("placeholder.email")}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <Message
        content={
          <>
            {t("reportContent.privacyPolicyMessage")}{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://simplydo.co.uk/privacy-policy"
            >
              {t("reportContent.privacyPolicy")}
            </a>
            .
          </>
        }
      />
      <div style={{ textAlign: "right" }}>
        <Button content={t("generic.cancel")} onClick={() => onComplete?.()} />
        <Button
          primary
          content={t("reportContent.submit")}
          onClick={() => reportContent()}
        />
      </div>
    </Form>
  );
};

export default ReportContent;
